<script setup lang="ts">
import BSnackbar from '../BSnackbar/BSnackbar.vue'

import { useSnackbar } from '../../composables/use-snackbar'

const snackbar = useSnackbar()
</script>

<template>
	<BSnackbar
		v-model="snackbar.isVisible.value"
		:color="snackbar.current.value?.color"
		:advanced="snackbar.current.value?.advanced"
		:title="snackbar.current.value?.title"
		:description="snackbar.current.value?.description"
		:closable="snackbar.current.value?.closable"
		:close-icon="snackbar.current.value?.closeIcon"
		:has-progress="snackbar.current.value?.hasProgress"
		:duration="snackbar.current.value?.duration"
		:position="snackbar.current.value?.position"
		:action-text="snackbar.current.value?.actionText"
		:icon="snackbar.current.value?.icon"
		:teleport-to="snackbar.current.value?.teleportTo"
		@click:close="snackbar.current.value?.['click:close']"
		@click:action="snackbar.current.value?.['click:action']"
		@update:model-value="snackbar.current.value?.['update:modelValue']"
		@after-leave="snackbar.onAfterLeave"
	/>
</template>
